import * as React from 'react';
import { renderProductDefinition } from '../../../MakeAChange/Helpers';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { get, head, isEmpty, map } from 'lodash';
import { Field, FieldArray } from 'redux-form';
import { IQuoteActions } from '../../../../../../services/quote/models';
import { IBrandingActions, IBrandingState, II18nMessages } from '../../../../../../services/branding/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';
import { IPolicyApplication } from '../../../../../../data/api/models';
import Travellers from '../../../../../Quote/scenes/TravellersDetails/components/Travellers';
import ChangeMedical from '../ChangeMedical';
import { MTACardHeader } from '../../../MakeAChange/components/CoverDetails/scenes/Components/MTACardHeader';
import { IVeriskState } from '../../../../../../services/verisk/models';

export interface IChangeTravellersProps {
  formValues: IPolicyApplication;
  change: any;
  dispatch: any;
  isLoading: boolean;
  branding: IBrandingState;

  handleSubmitForm(): any;

  synchronousError: any;

  touch(form: string, field: string): void

  i18n: II18nMessages;
  actions: {
    branding: IBrandingActions;
    quote: IQuoteActions;
    calculate: any;
    push: (route: string) => void;
  };
  verisk?: IVeriskState;
  goBackButton: any;
}

export interface IChangeTravellersState {
  showScreening: boolean;
}

class ChangeTravellers extends React.Component<IChangeTravellersProps, IChangeTravellersState> {
  constructor(props) {
    super(props);

    this.state = {
      showScreening: false
    }
  }

  private renderGroupTypes = (name, key) => {
    const { i18n, actions, formValues } = this.props;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const groupType = formValues.groupType;
    const premium = head(get(formValues, 'premiums', []))
    const hasGroup = get(premium, 'information.hasGroups', false)

    if (groupType !== 'group' && !hasGroup && key === 'group') {
      return null;
    }

    return (
      <Col xs={6}>
        <div className="group-type-selection">
          <div key={key}>
            <Field
              name="groupType"
              type="radio"
              value={key}
              component={FieldFormControl}
              validate={[isRequired]}
            >
              <div/>
              {name} {' '}
            </Field>
          </div>
          <div>
            {renderDefinition(`groupTypeDescriptions${key}`,
              i18n.quote.tripDetails.groupTypeDescriptions[key])}
          </div>

        </div>
      </Col>
    );
  }

  private handleOnClickNext = () => {
    const { touch, synchronousError } = this.props;
    const errors = get(synchronousError, 'travellers', []);

    const mappedErrors = errors.map((item) => {
      if (isEmpty(item) || item === undefined || JSON.stringify(item) === '{}') {
        return undefined;
      }
      return item;
    })

    const noErrors = mappedErrors.filter(item => item);

    if (!isEmpty(noErrors)) {
      errors.forEach((item, index) => {
        if (item) {
          const title = get(item, 'title')
          const firstName = get(item, 'firstName')
          const lastName = get(item, 'lastName')
          const dob = get(item, 'dob')
          if (title) {
            touch('quote', `travellers.[${index}].title`)
          }
          if (firstName) {
            touch('quote', `travellers.[${index}].firstName`)
          }
          if (lastName) {
            touch('quote', `travellers.[${index}].lastName`)
          }
          if (dob) {
            touch('quote', `travellers.[${index}].dob`)
          }
        }
      })
    }
    if (isEmpty(noErrors)) {
      this.setState({ showScreening: true })
    }
  }

  render() {
    const {
      actions,
      i18n,
      change,
      dispatch,
      branding,
      formValues,
      handleSubmitForm,
      isLoading,
      synchronousError,
      verisk,
      goBackButton
    } = this.props;
    const { showScreening } = this.state;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const groupType = formValues.groupType;
    const tripType = formValues.tripType;

    return (
      <>
        <div>
          <div className="admiral-card mt-30">
            <MTACardHeader text={'Please answer the following questions.'}/>
            <Grid fluid={true}>
              {!showScreening && (
                <div>
                  <p style={{ marginTop: '20px' }}>Please tell us who will be travelling</p>
                  <div className="radio-group margin-top section-divider ">
                    <Row className="dynamic-row">
                      {map(product.metadata[`group_type_trip_${tripType}`], (name, key) => {
                        return this.renderGroupTypes(name, key);
                      })}
                    </Row>
                  </div>

                  <FieldArray
                    name="travellers"
                    i18n={i18n}
                    product={product}
                    component={Travellers}
                    groupType={groupType}
                    renderDefinition={renderDefinition}
                    change={change}
                    isRenewal={true}
                  />

                </div>
              )}

              {showScreening && (
                <div>
                  <ChangeMedical
                    formValues={formValues}
                    synchronousError={synchronousError}
                    product={product}
                    branding={branding}
                    renderDefinition={renderDefinition}
                    handleSubmitForm={handleSubmitForm}
                    dispatch={dispatch}
                    change={change}
                    submitting={isLoading}
                    i18n={i18n}
                    verisk={verisk}
                  />
                </div>
              )}

              {!showScreening && (
                <div className={'renewal-edit-form-buttons'} style={{ marginBottom: '20px' }}>
                  <div className={'renewal-go-back-button'}>
                    {goBackButton}
                  </div>
                  <div className={'renewal-submit-button'}>
                    <Button
                      bsStyle="primary"
                      type="button"
                      className="medium-width pull-right mb-20 secondary-button"
                      disabled={isLoading}
                      onClick={this.handleOnClickNext}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}
            </Grid>
          </div>
        </div>
      </>
    );
  }
}

export default ChangeTravellers;
